<div class="login-page">

  <!-- Painel esquerdo - Branding -->
  <div class="login-branding">
    <div class="branding-content">
      <img src="assets/icon-clinixcore-light.svg" alt="ClinixCore" class="brand-icon-hero">
      <h1 class="brand-title">ClinixCore</h1>
      <p class="brand-subtitle">O núcleo da sua prática clínica</p>
      <p class="brand-description">Crie uma nova senha segura para sua conta</p>
      <div class="brand-features">
        <div class="feature-item"><i class="bi bi-shield-lock"></i> Criptografia segura</div>
        <div class="feature-item"><i class="bi bi-key-fill"></i> Senha forte recomendada</div>
        <div class="feature-item"><i class="bi bi-check-circle"></i> Acesso restaurado</div>
      </div>
    </div>
  </div>

  <!-- Painel direito - Formulário -->
  <div class="login-form-panel">
    <div class="login-card">

      <!-- Logo Mobile -->
      <div class="text-center mb-4 d-md-none">
        <img src="assets/logo-clinixcore.svg" alt="ClinixCore" style="height: 45px;">
      </div>

      <!-- Título compacto -->
      <div class="text-center mb-3">
        <h2 class="h5 mb-2 fw-semibold text-dark">
          <i class="bi bi-shield-lock text-primary me-2"></i>
          Redefinir senha
        </h2>
        <p class="text-muted small mb-0" *ngIf="!passwordReset">
          Crie uma nova senha forte para sua conta
        </p>
      </div>

      <!-- Espaçador para alinhamento -->
      <div class="mb-5"></div>

      <!-- Mensagem de sucesso -->
      <div class="alert alert-success d-flex align-items-start gap-2 mb-3" *ngIf="passwordReset && successMessage">
        <i class="bi bi-check-circle-fill fs-5 flex-shrink-0"></i>
        <div>
          <strong>Senha redefinida!</strong>
          <p class="mb-0 mt-1">{{ successMessage }}</p>
        </div>
      </div>

      <!-- Mensagem de erro -->
      <div class="alert alert-danger d-flex align-items-start gap-2 mb-3" *ngIf="errorMessage">
        <i class="bi bi-exclamation-triangle-fill flex-shrink-0"></i>
        <div>
          <span>{{ errorMessage }}</span>
          <p class="mb-0 mt-2 small" *ngIf="errorMessage.includes('Token')">
            <a href="/forgot-password" class="text-danger fw-semibold">Clique aqui para solicitar um novo link</a>
          </p>
        </div>
      </div>

      <!-- Formulário -->
      <form [formGroup]="resetForm" (ngSubmit)="onSubmit()" *ngIf="!passwordReset">

        <div class="mb-3">
          <label class="form-label">Nova senha</label>
          <div class="input-password">
            <input [type]="showPassword ? 'text' : 'password'"
                   class="form-control" formControlName="password"
                   placeholder="••••••••"
                   [class.is-invalid]="f['password'].invalid && f['password'].touched">
            <button type="button" class="btn-eye" (click)="showPassword = !showPassword">
              <i class="bi" [class.bi-eye]="!showPassword" [class.bi-eye-slash]="showPassword"></i>
            </button>
          </div>
          <div class="invalid-feedback d-block"
               *ngIf="f['password'].invalid && f['password'].touched">
            <span *ngIf="f['password'].hasError('required')">Senha obrigatória</span>
            <span *ngIf="f['password'].hasError('minlength')">A senha deve ter pelo menos 6 caracteres</span>
          </div>
          <div class="form-text">
            <i class="bi bi-info-circle"></i>
            Use pelo menos 6 caracteres com letras e números
          </div>
        </div>

        <div class="mb-4">
          <label class="form-label">Confirmar nova senha</label>
          <div class="input-password">
            <input [type]="showConfirmPassword ? 'text' : 'password'"
                   class="form-control" formControlName="confirmPassword"
                   placeholder="••••••••"
                   [class.is-invalid]="(f['confirmPassword'].invalid || resetForm.hasError('passwordMismatch')) && f['confirmPassword'].touched">
            <button type="button" class="btn-eye" (click)="showConfirmPassword = !showConfirmPassword">
              <i class="bi" [class.bi-eye]="!showConfirmPassword" [class.bi-eye-slash]="showConfirmPassword"></i>
            </button>
          </div>
          <div class="invalid-feedback d-block"
               *ngIf="f['confirmPassword'].touched && (f['confirmPassword'].invalid || resetForm.hasError('passwordMismatch'))">
            <span *ngIf="f['confirmPassword'].hasError('required')">Confirmação obrigatória</span>
            <span *ngIf="resetForm.hasError('passwordMismatch') && !f['confirmPassword'].hasError('required')">
              As senhas não coincidem
            </span>
          </div>
        </div>

        <button type="submit" class="btn btn-primary w-100 mb-3" [disabled]="loading">
          <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"></span>
          {{ loading ? 'Redefinindo...' : 'Redefinir senha' }}
        </button>
      </form>

      <!-- Botão voltar -->
      <button type="button" class="btn btn-outline-secondary w-100" (click)="goToLogin()">
        <i class="bi bi-arrow-left me-2"></i>
        Voltar para o login
      </button>

      <!-- Link de ajuda -->
      <div class="text-center mt-4">
        <p class="text-muted small mb-0">
          Problemas para redefinir? <a href="/forgot-password" class="link-primary">Solicite um novo link</a>
        </p>
      </div>

    </div>
  </div>

</div>
